import React from "react";
import {
  FaHardHat,
  FaTools,
  FaRoad,
  FaTruckMoving,
  FaWater,
  FaBorderAll,
} from "react-icons/fa";
import Service1 from "../../images/services/earthwork.jpg";
import Service2 from "../../images/services/utilities.jpg";
import Service3 from "../../images/services/IMG_2370.jpg";
import Service4 from "../../images/services/round.jpg";
import Service5 from "../../images/services/DSC_2376.jpg";
import Service7 from "../../images/services/DJI_0098.jpg";
import ServiceArea from "../../images/BRW Service Area.png";

const Services = () => {
  const services = [
    {
      title: "Earthwork",
      desc: "Expert grading, excavation, and land clearing solutions for any project size.",
      img: Service1,
      link: "/earthwork",
      icon: <FaHardHat />,
    },
    {
      title: "Underground Utilities",
      desc: "Installation and maintenance of water, sewer, and storm systems with precision.",
      img: Service2,
      link: "/undergroundUtilities",
      icon: <FaWater />,
    },
    {
      title: "Concrete",
      desc: "From cast-in-place to curbs and sidewalks, we handle all concrete construction.",
      img: Service3,
      link: "/concrete",
      icon: <FaTruckMoving />,
    },
    {
      title: "Roadway Construction",
      desc: "Comprehensive roadway solutions from design to final paving and striping.",
      img: Service4,
      link: "/roadwayConstruction",
      icon: <FaRoad />,
    },
    {
      title: "Paving & Striping",
      desc: "Complete paving and striping services for roads, driveways, and parking lots.",
      img: Service5,
      link: "/pavingStriping",
      icon: <FaTools />,
    },
    {
      title: "Retaining Walls",
      desc: "Durable and visually appealing segmented block retaining wall construction.",
      img: Service7,
      link: "/segmentedRetainingWalls",
      icon: <FaBorderAll />,
    },
  ];

  return (
    <>
      {/* PAGE TITLE */}
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Services</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Homepage" href="/">
                      <i className="fa fa-house" /> &nbsp; Home
                    </a>
                  </span>
                  <span>Services</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SERVICE AREA */}
      <section className="py-5 bg-light">
        <div className="container text-center">
          <div className="section-title mb-4">
            <h3>Our Service Area</h3>
            <h2 className="title">
              Proudly Serving <span>Central Florida</span>
            </h2>
          </div>
          <img
            src={ServiceArea}
            alt="BRW Service Area"
            className="img-fluid service-area-img"
          />
        </div>
      </section>

      {/* SERVICES */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="section-title text-center mb-5">
            <h3>What We Do</h3>
            <h2 className="title">
              Full-Service Site Development <span>Solutions</span>
            </h2>
          </div>

          <div className="row g-4">
            {services.map((service, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="service-card h-100">
                  <div className="img-wrapper">
                    <img src={service.img} alt={service.title} />
                    <div className="overlay">
                      <div className="icon-box">{service.icon}</div>
                    </div>
                  </div>
                  <div className="card-body text-center">
                    <h5>{service.title}</h5>
                    <p>{service.desc}</p>
                    <a href={service.link} className="service-btn">
                      Learn More
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===================== FIXED + ENHANCED CSS ===================== */}
      <style jsx>{`
        .service-area-img {
          max-width: 700px;
          border-radius: 8px;
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
        }

        .service-card {
          border: 1px solid rgba(12, 45, 98, 0.08);
          border-radius: 8px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 14px 34px rgba(12, 45, 98, 0.08);
          transition: all 0.4s ease;
        }

        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 26px 55px rgba(12, 45, 98, 0.16);
        }

        .img-wrapper {
          position: relative;
          height: 240px;
          overflow: hidden;
        }

        .img-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .service-card:hover img {
          transform: scale(1.12);
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            135deg,
            rgba(255, 168, 0, 0.85),
            rgba(0, 0, 0, 0.6)
          );
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .service-card:hover .overlay {
          opacity: 1;
        }

        .icon-box {
          background: #fff;
          color: #ffa800;
          font-size: 2rem;
          padding: 18px;
          border-radius: 50%;
          transform: scale(0.7);
          transition: transform 0.4s ease;
        }

        .service-card:hover .icon-box {
          transform: scale(1);
        }

        .card-body {
          padding: 28px 22px;
        }

        .card-body h5 {
          font-weight: 800;
          margin-bottom: 10px;
        }

        .card-body p {
          color: #555;
          font-size: 0.95rem;
          margin-bottom: 20px;
        }

        .service-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          min-height: 42px;
          padding: 0 22px;
          border: 1px solid rgba(12, 45, 98, 0.16);
          border-radius: 999px;
          background: #0c2d62;
          color: #fff;
          font-weight: 700;
          letter-spacing: 0;
          box-shadow: 0 12px 24px rgba(12, 45, 98, 0.18);
          transition: transform 0.25s ease, background 0.25s ease,
            border-color 0.25s ease, color 0.25s ease;
        }

        .service-btn::after {
          content: "›";
          font-size: 1.35rem;
          line-height: 1;
          color: #ffa800;
          transition: transform 0.25s ease, color 0.25s ease;
        }

        .service-btn:hover {
          transform: translateY(-2px);
          background: #ffa800;
          border-color: #ffa800;
          color: #0c2d62;
        }

        .service-btn:hover::after {
          color: #0c2d62;
          transform: translateX(3px);
        }
      `}</style>
    </>
  );
};

export default Services;
